import Swiper, { Navigation, Pagination, Thumbs, A11y } from 'swiper'
import { openLightBox } from './pdp-lightbox'

import 'swiper/css'

Swiper.use([Navigation, Pagination, Thumbs, A11y])

if (document.querySelector('.product-recommendations .swiper')) {
  document
    .querySelectorAll('.product-recommendations .swiper')
    .forEach((el) => {
      let parentContainer = el.closest('.slider')

      let paginationEl = parentContainer.querySelector('.swiper-pagination')
      let navigationPrev = parentContainer.querySelector('.swiper-button-prev')
      let navigationNext = parentContainer.querySelector('.swiper-button-next')

      new Swiper(el, {
        preloadImages: false,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 24,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          767: {
            spaceBetween: 32,
          },
        },
        navigation: {
          prevEl: navigationPrev,
          nextEl: navigationNext,
        },
      })
    })
}

var swiper = Swiper
var init = false

function enableSwiper() {
  swiper = new Swiper('.product-converter__thumbnails', {
    preloadImages: true,
    loop: true,
    slidesPerView: 1.1,
    centeredSlides: false,
    watchSlidesProgress: true,
    a11y: {
      enabled: false,
    },
    grabCursor: true,
    spaceBetween: 16,
  })

  swiper.on('click', function () {
    console.log(this.realIndex)
    openLightBox(this.realIndex)
  })
}

function swiperMode() {
  let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)')
  let desktop = window.matchMedia('(min-width: 1025px)')

  if (mobile.matches) {
    if (!init) {
      init = true
      enableSwiper()
    }
  }

  // Disable (for desktop)
  else if (desktop.matches) {
    if (init) {
      swiper.destroy()
    }
    init = false
  }
}

/* On Load
 **************************************************************/
swiperMode()

/* On Resize
 **************************************************************/
window.addEventListener('resize', function () {
  swiperMode()
})
